import React from "react";
import LocationList from "./LocationList";
import TransportOptions from "./TransportOptions"; // adjust path if needed

const EventLocation = ({ data, onChange }) => {
  return (
    <div className="space-y-6">
      <LocationList data={data} onChange={onChange} />
      <TransportOptions transport={data.transport} onChange={onChange} />
    </div>
  );
};

export default EventLocation;
